import Menu from 'adeliom-menu-js';

const stickySelector = '.js-sticky-block';
const header = document.querySelector('[js-menu-sticky]');
const stickyBlock = document.querySelector(stickySelector);
if (stickyBlock) {
    stickyBlock.style.top = header.getBoundingClientRect().height + 'px';
}

const settings = {
    stickyScrollTop: true,
    'responsiveBreakpoint': 1280,
    closeMenuOnScroll: true,
}

const settingsStickyBlock = {
    stickySelector: stickySelector,
    stickyOffset: stickyBlock ? stickyBlock.getBoundingClientRect().top : 0,
    stickyScrollTop: true
}

const menu = new Menu(stickyBlock ? settingsStickyBlock : settings);

menu.init();

//Mouseenter et Mouseleave
const mainMenu = document.querySelector('[js-menu]');
const menuOverlay = document.querySelector('[js-menu-overlay]');
const menuHoveredClass = 'is-open';
const overlayHoveredClass = 'is-visible';
const menuLinkClass = 'is-active';


const linkHasChildren = mainMenu?.querySelectorAll('[js-menu-haschildren].first-level');

window.addEventListener("DOMContentLoaded", () => {

    const reset = (link, submenu, menuLink) => {
        if (link.classList.contains(menuLinkClass)) {
            link.classList.remove(menuLinkClass);
        }
        if (submenu.classList.contains(menuHoveredClass)) {
            submenu.classList.remove(menuHoveredClass);
        }
        if (menuLink.classList.contains(menuLinkClass)) {
            menuLink.classList.remove(menuLinkClass);
        }
    }

    const active = (link, submenu, menuLink) => {
        link.classList.add(menuLinkClass);
        submenu.classList.add(menuHoveredClass);
        menuLink.classList.add(menuLinkClass);
    }

    const resetAllItem = (linkHasChildren ) => {
        linkHasChildren?.forEach((el) => {
            reset(el, el.querySelector('[js-menu-sublevel]'), el.querySelector('[js-menu-link]'));
        });
    }

    if (window.window.innerWidth > 1023) {
        window.addEventListener('scroll', () => {
            linkHasChildren?.forEach((element) => {
                reset(element, element.querySelector('[js-menu-sublevel]'), element.querySelector('[js-menu-link]'));
                menuOverlay.classList.remove(overlayHoveredClass);
            })
        });

        linkHasChildren?.forEach((link) => {

            const submenu = link.querySelector('[js-menu-sublevel]');
            const menuLink = link.querySelector('[js-menu-link]');


            link.addEventListener('mouseenter', () => {
                resetAllItem(linkHasChildren)
                if (!submenu.classList.contains(menuHoveredClass)) {
                    menuOverlay.classList.add(overlayHoveredClass);
                    active(link, submenu, menuLink);
                }
            });


            submenu.addEventListener('mouseleave', () => {
                resetAllItem(linkHasChildren)
                menuOverlay.classList.remove(overlayHoveredClass);
                if (submenu.classList.contains(menuHoveredClass)) {
                    reset(link, submenu, menuLink);
                    menuOverlay.classList.remove(overlayHoveredClass);
                }
            });
        })
    }
});
